//@ts-ignore
import { GatewayProvider } from '@civic/solana-gateway-react';
import * as anchor from '@project-serum/anchor';
import {
  ASSOCIATED_TOKEN_PROGRAM_ID,
  Token,
  TOKEN_PROGRAM_ID,
} from '@solana/spl-token';
import { useWallet } from '@solana/wallet-adapter-react';
import { PublicKey } from '@solana/web3.js';
import { useCallback, useEffect, useMemo, useState } from 'react';
import Container from '../../common/Container';
import {
  awaitTransactionSignatureConfirmation,
  CandyMachineAccount,
  CANDY_MACHINE_PROGRAM,
  getCandyMachineState,
  mintOneToken,
} from './candy-machine';
import { MintButton } from './MintButton';
import MintNavigation from './MintNavigation';
import {
  Heading,
  Hero,
  MintCount,
  NftWrapper,
  NftWrapper2,
  Root,
} from './styles';

export interface Props {
  candyMachineId?: anchor.web3.PublicKey;
  connection: anchor.web3.Connection;
  startDate: number;
  txTimeout: number;
  rpcHost: string;
}

export const Mint = (props: Props) => {
  const [tokenBalance, setTokenBalance] = useState<number>(0);
  const [isUserMinting, setIsUserMinting] = useState(false);
  const [candyMachine, setCandyMachine] = useState<CandyMachineAccount>();
  // const [alertState, setAlertState] = useState<AlertState>({
  //   open: false,
  //   message: '',
  //   severity: undefined,
  // });

  // @ts-ignore
  const { tokenMint } = useMemo(
    () => candyMachine?.state || {},
    [candyMachine]
  ); // Custom spl token for mint price. Typically undefined
  const [associatedTokenAccountAddress, setAssociatedTokenAccountAddress] =
    useState(undefined); // Associated token for custom spl mint

  const rpcUrl = props.rpcHost;
  const wallet = useWallet();

  const anchorWallet = useMemo(() => {
    if (
      !wallet ||
      !wallet.publicKey ||
      !wallet.signAllTransactions ||
      !wallet.signTransaction
    ) {
      return;
    }

    return {
      publicKey: wallet.publicKey,
      signAllTransactions: wallet.signAllTransactions,
      signTransaction: wallet.signTransaction,
    } as anchor.Wallet;
  }, [wallet]);

  const refreshCandyMachineState = useCallback(async () => {
    if (!anchorWallet) {
      return;
    }

    if (props.candyMachineId) {
      try {
        const cndy = await getCandyMachineState(
          anchorWallet,
          props.candyMachineId,
          props.connection
        );
        setCandyMachine(cndy);
      } catch (e) {
        console.log('There was a problem fetching Candy Machine state');
        console.log(e);
      }
    }
  }, [anchorWallet, props.candyMachineId, props.connection]);

  const onMint = async () => {
    try {
      setIsUserMinting(true);
      document.getElementById('#identity')?.click();
      if (wallet.connected && candyMachine?.program && wallet.publicKey) {
        const mintTxId = (
          await mintOneToken(candyMachine, wallet.publicKey)
        )[0];

        let status: any = { err: true };
        if (mintTxId) {
          status = await awaitTransactionSignatureConfirmation(
            mintTxId,
            props.txTimeout,
            props.connection,
            true
          );
        }

        if (status && !status.err) {
          // setAlertState({
          //   open: true,
          //   message: 'Congratulations! Mint succeeded!',
          //   severity: 'success',
          // });
        } else {
          // setAlertState({
          //   open: true,
          //   message: 'Mint failed! Please try again!',
          //   severity: 'error',
          // });
        }
      }
    } catch (error: any) {
      let message = error.msg || 'Minting failed! Please try again!';
      if (!error.msg) {
        if (!error.message) {
          message = 'Transaction Timeout! Please try again.';
        } else if (error.message.indexOf('0x137')) {
          message = `SOLD OUT!`;
        } else if (error.message.indexOf('0x135')) {
          message = `Insufficient funds to mint. Please fund your wallet.`;
        }
      } else {
        if (error.code === 311) {
          message = `SOLD OUT!`;
          window.location.reload();
        } else if (error.code === 312) {
          message = `Minting period hasn't started yet.`;
        }
      }
      console.log(message);

      // setAlertState({
      //   open: true,
      //   message,
      //   severity: 'error',
      // });
    } finally {
      setIsUserMinting(false);
    }
  };

  useEffect(() => {
    refreshCandyMachineState();
  }, [
    anchorWallet,
    props.candyMachineId,
    props.connection,
    refreshCandyMachineState,
  ]);

  const updateBalance = async () => {
    if (wallet.publicKey) {
      if (tokenMint) {
        if (associatedTokenAccountAddress) {
          const token = new Token(
            props.connection,
            tokenMint,
            TOKEN_PROGRAM_ID,
            //@ts-ignore
            wallet
          );
          const mintInfo = await token.getMintInfo();

          try {
            const associatedTokenAccountInfo = await token.getAccountInfo(
              associatedTokenAccountAddress
            );
            setTokenBalance(
              associatedTokenAccountInfo.amount.toNumber() /
                10 ** mintInfo.decimals
            );
          } catch (e) {
            // if we cant fatch associated address, assume balance is 0
            setTokenBalance(0);
          }
        } else {
          // @ts-ignore
          const associatedTokenAccountAddrs =
            await Token.getAssociatedTokenAddress(
              ASSOCIATED_TOKEN_PROGRAM_ID,
              TOKEN_PROGRAM_ID,
              tokenMint,
              wallet.publicKey
            );
          // @ts-ignore
          setAssociatedTokenAccountAddress(associatedTokenAccountAddrs);
        }
      }
      // const balance = await props.connection.getBalance(wallet.publicKey);
      // setBalance(balance / LAMPORTS_PER_SOL);
    }
  };
  useEffect(() => {
    (async () => {
      await updateBalance();
    })();
  }, [wallet, props.connection, tokenMint]);
  return (
    <Root>
      <div className='cloud-content'>
        {[...Array(7)].map((cloud, index) => (
          <div key={index} className={`cloud-${index + 1} cloud-block`}>
            <div className='cloud'></div>
          </div>
        ))}
      </div>
      <Container>
        <MintNavigation />

        <Hero>
          <Heading>
            About <br /> Malibu NFTs
          </Heading>

          <p>
            1000 unikely generated Dolphis that have integraed to the clear and
            warner network of SOlana.
            <br /> Drawn by hand and assemmbeled by code, not one Whale is the
            same!
          </p>

          <MintCount>
            {candyMachine ? `${candyMachine?.state.itemsRedeemed} /` : ''} 1001
          </MintCount>

          {candyMachine?.state.isActive &&
          candyMachine?.state.gatekeeper &&
          wallet.publicKey &&
          wallet.signTransaction ? (
            <GatewayProvider
              wallet={{
                publicKey:
                  wallet.publicKey || new PublicKey(CANDY_MACHINE_PROGRAM),
                //@ts-ignore
                signTransaction: wallet.signTransaction,
              }}
              gatekeeperNetwork={
                candyMachine?.state?.gatekeeper?.gatekeeperNetwork
              }
              clusterUrl={rpcUrl}
              options={{ autoShowModal: false }}
            >
              <MintButton
                candyMachine={candyMachine}
                isMinting={isUserMinting}
                onMint={onMint}
              />
            </GatewayProvider>
          ) : (
            <MintButton
              candyMachine={candyMachine}
              isMinting={isUserMinting}
              onMint={onMint}
            />
          )}
        </Hero>
      </Container>
      <NftWrapper>
        <div className='marquee-wrapper'>
          <div className='marquee'>
            {[...Array(150)].map((item, index) => (
              <img
                key={index}
                src={`/img/nfts/${index}.png`}
                height='200px'
                width='200px'
                alt='nft'
              />
            ))}
          </div>
        </div>
      </NftWrapper>
      <NftWrapper2>
        <div className='marquee-wrapper second'>
          <div className='marquee'>
            {[...Array(150)].map((item, index) => (
              <img
                key={index}
                src={`/img/nfts/${index + 150}.png`}
                height='200px'
                width='200px'
                alt='nft'
              />
            ))}
          </div>
        </div>
      </NftWrapper2>
    </Root>
  );
};
